import { HasKind } from '@/utilities/HasKind';

export const kind = 'SuspendComplete';

export type SuspendComplete = HasKind<typeof kind>;

// Singleton-ish instance for convenience.
export const suspendComplete: SuspendComplete = { kind };
